import * as App from '../../app';
import { Coins } from '../../components';
export function coinsBar(game, storeModal) {
    var coins = new Coins({
        onClick: function () {
            if (game.isTimerEffect()) {
                App.sounds.disabled();
                return;
            }
            App.sounds.click();
            storeModal.show();
        },
    });
    return coins;
}
